import { createSelector } from '@ngrx/store';
import { AppState } from 'src/store';
import { FlightLogSummaryEntity } from './flight-log-summary.model';

export const selectAllFlightLogSummaries = (state: AppState) => state.flightLogSummaries.entities;

export function selectFlightLogSummaryById(id: string) {
  return createSelector(selectAllFlightLogSummaries, (flightLogs) => {
    return flightLogs[id] as FlightLogSummaryEntity | undefined;
  });
}
